import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RequireAuth } from './auth/RequireAuth';
import { AppShell } from './components/layout/AppShell';
import { Spinner } from './components/common/Spinner';
import { LoginPage } from './pages/auth/LoginPage';
import { SignupPage } from './pages/auth/SignupPage';
import { OnboardingPage } from './pages/auth/OnboardingPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { ActiveVisitsPage } from './pages/visits/ActiveVisitsPage';
import { UpcomingVisitsPage } from './pages/visits/UpcomingVisitsPage';
import { PastVisitsPage } from './pages/visits/PastVisitsPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { BookPage } from './pages/booking/BookPage';
import { SmsConsentPage } from './pages/static/SmsConsentPage';
import { PrivacyPage } from './pages/static/PrivacyPage';
import { TermsPage } from './pages/static/TermsPage';
import { ThankYouPage } from './pages/static/ThankYouPage';

const VisitPage = lazy(() => import('./pages/visit/VisitPage'));
const ChatPage = lazy(() => import('./pages/chat/ChatPage'));

export function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route
        path="/visit"
        element={
          <Suspense fallback={<Spinner fullPage />}>
            <VisitPage />
          </Suspense>
        }
      />
      <Route path="/book/:practiceId" element={<BookPage />} />
      <Route path="/sms-consent" element={<SmsConsentPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/thankyou" element={<ThankYouPage />} />

      {/* Authenticated without shared layout (onboarding) */}
      <Route element={<RequireAuth />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/chat/:visitId?" element={
          <Suspense fallback={<Spinner fullPage />}>
            <ChatPage />
          </Suspense>
        } />
      </Route>

      {/* Authenticated with shared layout */}
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/active" element={<ActiveVisitsPage />} />
          <Route path="/upcoming" element={<UpcomingVisitsPage />} />
          <Route path="/past" element={<PastVisitsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
